export default function NotFound() {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>404</h1>
        <p>Oops! Page not found.</p>
      </div>
    );
  }
  